import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import { CreateMemberForm } from '../CreateMemberForm'
import NavigateBackButton from '@/common/components/NavigateBackButton'

export default function CreateMemberListing() {
	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading title={`สร้างผู้ใช้งาน`} description="สร้างผู้ใช้งาน" />
				<NavigateBackButton />
			</div>
			<Separator />
			<CreateMemberForm />
		</div>
	)
}
